export const LABELS_FILTER = 'LABELS_FILTER';
export const STATUS_FILTER = 'STATUS_FILTER';
export const OUTCOME_FILTER = 'OUTCOME_FILTER';
export const RECEIVER_FILTER = 'RECEIVER_FILTER';
